// 5x5 bitmap font for the SIDESTACK pixel wordmark.
// Used by both the on-page wordmark and the OG image generator.
export const PIXEL_FONT: Record<string, string[]> = {
  S: ["01110", "10000", "01110", "00001", "11110"],
  I: ["11111", "00100", "00100", "00100", "11111"],
  D: ["11100", "10010", "10010", "10010", "11100"],
  E: ["11111", "10000", "11110", "10000", "11111"],
  T: ["11111", "00100", "00100", "00100", "00100"],
  A: ["01110", "10001", "11111", "10001", "10001"],
  C: ["01111", "10000", "10000", "10000", "01111"],
  K: ["10010", "10100", "11000", "10100", "10010"],
};
